// src/app/auth-config.ts

import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'a4029aa9-3f09-4458-94cc-1da7acef0554', // Substitua pelo seu Application ID
    authority: 'https://sigvarisgroupcust.b2clogin.com/sigvarisgroupcust.onmicrosoft.com/B2C_1_mtmapp_signin',
    knownAuthorities: ['sigvarisgroupcust.b2clogin.com'],
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        console.log(message);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile']
};
